/* Quiz "Monte sua rotina" v2 — fluxo, montagem da rotina e resultado.
   Add-to-cart e captura de e-mail: ver bloco CART/EMAIL abaixo (Task 3). */
(function () {
  function initQuiz(root) {
    var dataEl = root.querySelector('[data-quiz-json]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { routines: {} }; }

    var state = { goal: null, goal2: null, format: null };
    var stepOrder = ['goal', 'goal2', 'format'];
    var currentStep = 1;
    var currentRoutine = null;

    function showStep(n) {
      currentStep = n;
      root.classList.remove('is-finished');
      root.querySelector('[data-quiz-result]').classList.remove('is-active');
      root.querySelectorAll('.c-quiz__step').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-step') === String(n));
      });
      root.querySelectorAll('[data-progress]').forEach(function (p) {
        p.classList.toggle('is-done', parseInt(p.getAttribute('data-progress'), 10) < n);
      });
      if (n === 2) {
        root.querySelectorAll('[data-goal2-options] [data-value]').forEach(function (b) {
          if (b.getAttribute('data-value') === state.goal) { b.setAttribute('hidden', ''); }
          else { b.removeAttribute('hidden'); }
        });
      }
    }

    function addPick(list, p) {
      if (!p || !p.available) return;
      for (var i = 0; i < list.length; i++) { if (list[i].variantId === p.variantId) return; }
      list.push(p);
    }

    function buildRoutine() {
      var routines = data.routines || {};
      var r = routines[state.goal] || routines['base'];
      if (!r) return null;
      var picks = [];
      var heroi = r.heroi;
      if (state.format === 'gotas' && r.heroiGotas && r.heroiGotas.available) heroi = r.heroiGotas;
      addPick(picks, heroi);
      if (state.goal2 && state.goal2 !== 'none' && routines[state.goal2]) {
        addPick(picks, routines[state.goal2].heroi);
      }
      (r.compl || []).forEach(function (p) { if (picks.length < 3) addPick(picks, p); });
      return { just: r.just || '', items: picks.slice(0, 3) };
    }

    function productCard(p) {
      var li = document.createElement('li');
      li.className = 'c-quiz__product';
      var img = p.image ? '<img src="' + p.image + '" alt="" width="200" height="200" loading="lazy">' : '';
      li.innerHTML =
        '<a href="' + p.url + '">' + img +
        '<div class="c-quiz__product-info"><p class="c-quiz__product-title"></p>' +
        '<span class="c-quiz__product-price">' + p.price + '</span></div></a>' +
        '<button type="button" class="c-quiz__product-add" data-quiz-product-add>Adicionar só este</button>';
      li.querySelector('.c-quiz__product-title').textContent = p.title;
      li.querySelector('[data-quiz-product-add]').dataset.variantId = p.variantId;
      return li;
    }

    function renderResult(routine) {
      var result = root.querySelector('[data-quiz-result]');
      var list = root.querySelector('[data-quiz-products]');
      list.innerHTML = '';
      if (!routine || !routine.items.length) {
        root.querySelector('[data-quiz-just]').textContent = '';
        list.innerHTML = '<li class="c-quiz__fallback"><p>Estamos reorganizando as sugestões deste objetivo. ' +
          'Veja os <a href="/collections/mais-vendidos">mais vendidos</a> enquanto isso.</p></li>';
        root.querySelector('[data-add-routine]').setAttribute('hidden', '');
      } else {
        routine.items.forEach(function (p) { list.appendChild(productCard(p)); });
        root.querySelector('[data-quiz-just]').textContent = routine.just;
        var addBtn = root.querySelector('[data-add-routine]');
        addBtn.removeAttribute('hidden');
        addBtn.textContent = addBtn.textContent.replace(/\s*\(\d+.*\)$/, '') + ' (' + routine.items.length +
          (routine.items.length > 1 ? ' itens)' : ' item)');
      }
      root.querySelectorAll('.c-quiz__step').forEach(function (s) { s.classList.remove('is-active'); });
      root.querySelectorAll('[data-progress]').forEach(function (p) { p.classList.add('is-done'); });
      root.classList.add('is-finished');
      result.classList.add('is-active');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function finish() {
      currentRoutine = buildRoutine();
      renderResult(currentRoutine);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-answer]');
      if (opt && !opt.hasAttribute('hidden')) {
        var field = opt.getAttribute('data-answer');
        state[field] = opt.getAttribute('data-value');
        if (field === 'goal' && state.goal === 'kids') { finish(); return; }
        var idx = stepOrder.indexOf(field);
        if (idx === stepOrder.length - 1) { finish(); } else { showStep(idx + 2); }
        return;
      }
      if (e.target.closest('[data-quiz-back]')) { showStep(Math.max(1, currentStep - 1)); return; }
      if (e.target.closest('[data-quiz-restart]')) {
        state = { goal: null, goal2: null, format: null };
        currentRoutine = null;
        root.querySelector('[data-quiz-result]').classList.remove('is-active');
        root.querySelector('[data-quiz-email-ok]').classList.remove('is-visible');
        showStep(1);
        return;
      }
      /* CART/EMAIL: handlers adicionados na Task 3 usam currentRoutine/state */
      handleCartAndEmailClicks(e);
    });

    /* ==== CART/EMAIL ==== */
    function setLoading(btn, on) {
      btn.classList.toggle('is-loading', on);
      if (on) { btn.setAttribute('disabled', ''); } else { btn.removeAttribute('disabled'); }
    }

    function addToCart(items, btn) {
      if (!items.length) return;
      var errEl = root.querySelector('[data-quiz-cart-error]');
      errEl.classList.remove('is-visible');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items.map(function (p) { return { id: p.variantId, quantity: 1 }; }) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      setLoading(btn, true);
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) { errEl.classList.add('is-visible'); return; }
          if (window.NutrioneUX && typeof window.NutrioneUX.track === 'function') {
            window.NutrioneUX.track('add_to_cart', {
              source: 'quiz',
              item_count: items.length
            });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { errEl.classList.add('is-visible'); })
        .finally(function () { setLoading(btn, false); });
    }

    function captureEmail(btn) {
      var input = root.querySelector('[data-quiz-email]');
      var okEl = root.querySelector('[data-quiz-email-ok]');
      var email = input && input.value ? input.value.trim() : '';
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (input) input.focus(); return; }
      var goalTag = state.goal || 'geral';
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter, quiz, quiz-' + goalTag);
      setLoading(btn, true);
      fetch('/contact', { method: 'POST', body: fd })
        .catch(function () {})
        .finally(function () {
          setLoading(btn, false);
          okEl.classList.add('is-visible');
          input.value = '';
        });
    }

    function handleCartAndEmailClicks(e) {
      var routineBtn = e.target.closest('[data-add-routine]');
      if (routineBtn && currentRoutine) { addToCart(currentRoutine.items, routineBtn); return; }
      var singleBtn = e.target.closest('[data-quiz-product-add]');
      if (singleBtn && currentRoutine) {
        var vid = parseInt(singleBtn.dataset.variantId, 10);
        var item = currentRoutine.items.filter(function (p) { return p.variantId === vid; })[0];
        if (item) addToCart([item], singleBtn);
        return;
      }
      var emailBtn = e.target.closest('[data-quiz-email-send]');
      if (emailBtn) { captureEmail(emailBtn); return; }
    }
  }

  document.querySelectorAll('[data-c-quiz]').forEach(initQuiz);
})();
